import { ColorScheme } from "../../../.storyblok/types/287059/storyblok-components";
import { fallbackColorScheme } from "../../helpers/colorSchemes";
import { getImageSource } from "../../helpers/getImageSource";
import { getStoryblokImageUrl } from "../../helpers/images/getStoryblokImageUrl";
import classNames from "classnames/bind";
import styles from "./ProductSquare.module.css";

const cx = classNames.bind(styles);

export const ProductSquare = ({
  colorScheme,
  imageUrl,
  imageAlt,
}: {
  colorScheme: ColorScheme;
  imageUrl?: string;
  imageAlt?: string;
}) => {
  const backgroundStyle = {
    "--productBackgroundColor": (colorScheme ?? fallbackColorScheme)
      .secondaryColor,
  };

  const imageSource = imageUrl ? getImageSource(imageUrl) : null;

  return (
    <div style={backgroundStyle} className={cx("container")}>
      {imageUrl && (
        <>
          {imageSource === "storyblok" ? (
            <img
              className={cx("image")}
              src={getStoryblokImageUrl(imageUrl, {
                width: 352,
                height: undefined,
              })}
              alt={imageAlt}
            />
          ) : (
            <img
              style={backgroundStyle}
              className={cx("image")}
              src={imageUrl}
              alt={imageAlt}
            />
          )}
        </>
      )}
    </div>
  );
};
